var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v(" Read Only Mode ")]),_c('SwitchFlag',{attrs:{"value":_vm.readOnlyMode,"label-mapping":_vm.labelMapping},on:{"switchFlag":function($event){return _vm.manageReadMode({
      enabled: $event,
    })}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }